import React, { Component } from 'react';
import API from 'API';
import Loader from 'components/common/Loader';

//-------------------------------------------------------------------------------------------------------------------

class PersonalDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    async onSubmit() {
        const { bookingRequest, onNextClicked } = this.props;
        const { isBusy } = this.state;
        if (isBusy) return;
        this.setState({ isBusy: true, error: null });
        try {
            await API.call('book/update-personal-details', bookingRequest);
            onNextClicked();
        } catch (error) {
            this.setState({ error });
        } finally {
            this.setState({ isBusy: false });
        }
    }

    render() {
        const { bookingRequest, onChange, onBackClicked } = this.props;
        const { isBusy, error } = this.state;

        return (

            <form onSubmit={e => {
                e.preventDefault();
                this.onSubmit();
            }}>

                <h2>Now, a few details about you.</h2>

                <p className="subtitle">
                    This is so we can get in touch with you about your booking.
                </p>

                <p className="subtitle">
                    <span className="required-asterisk">*</span> Indicates required field
                </p>

                <div className="form-group mb-3">
                    <label>First Name</label>
                    <input
                        type="text"
                        className="form-control"
                        value={bookingRequest.customerFirstName || ''}
                        onChange={e => onChange({ customerFirstName: e.target.value })}
                        disabled={isBusy}
                    />
                </div>

                <div className="form-group required mb-3">
                    <label>Last Name</label>
                    <input
                        type="text"
                        className="form-control"
                        value={bookingRequest.customerLastName || ''}
                        onChange={e => onChange({ customerLastName: e.target.value })}
                        disabled={isBusy}
                        required
                    />
                </div>

                <div className="form-group required mb-3">
                    <label>Email Address</label>
                    <input
                        type="email"
                        className="form-control"
                        value={bookingRequest.customerEmail || ''}
                        onChange={e => onChange({ customerEmail: e.target.value })}
                        disabled={isBusy}
                        required
                    />
                </div>

                <div className="form-group required mb-3">
                    <label>Phone Number</label>
                    <input
                        type="tel"
                        className="form-control"
                        value={bookingRequest.customerTel || ''}
                        onChange={e => onChange({ customerTel: e.target.value })}
                        disabled={isBusy}
                        required
                    />
                </div>

                {!!error &&
                    <div className="alert alert-danger mt-3 mb-3">
                        {error}
                    </div>
                }

                <div className="nav-buttons">

                    {!isBusy &&
                        <button type="button" className="btn btn-secondary me-auto" onClick={() => onBackClicked()}>
                            Back
                        </button>
                    }

                    <button
                        type="submit"
                        className="btn ms-auto"
                        disabled={isBusy}
                    >
                        {isBusy ?
                            <><Loader isInline />{' '}Please Wait...</> :
                            <>Next</>
                        }
                    </button>

                </div>

            </form>
        );
    }

}

export default PersonalDetails;